import { render, staticRenderFns } from "./DeviceTypeChooser.vue?vue&type=template&id=2101cc6c&"
import script from "./DeviceTypeChooser.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeviceTypeChooser.vue"
export default component.exports